export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  image: string;
  imageAlt: string;
  tags: string[];
  featured: boolean;
  hot: boolean;
  views: number;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '京都四季：探寻日本古都的季节之美与传统匠人精神',
    excerpt: '从春樱到冬雪，京都的每一个季节都散发着独特的魅力。本文带您深入京都街头巷尾，感受千年古都的匠人传承与季节风物诗。',
    content: `<p>京都，这座拥有超过千年历史的日本古都，每一块石板路、每一座神社寺庙都在诉说着时光的故事。</p>
<h2>春之樱：花见文化</h2>
<p>每年三月下旬至四月上旬，京都便化身为粉色的梦境。哲学之道、岚山、醍醐寺——这些赏樱名所吸引着来自世界各地的游客。但真正的京都人知道，最美的樱花藏在那些不为人知的巷弄深处。</p>
<p>花见（はなみ）不仅仅是赏花，更是一种社交仪式。在樱花树下铺上蓝色的野餐垫，与亲朋好友共享便当与清酒，这是日本人对春天最隆重的礼赞。</p>
<h2>夏之祭：祇园祭的盛况</h2>
<p>七月的京都属于祇园祭。这个延续了超过一千年的传统祭典，以其华丽的山鉾巡行闻名于世。巨大的山鉾高达25米，由数十人合力拉动，穿行于京都的大街小巷。</p>
<p>夜幕降临后的宵山更是别有一番风味。四条通变为步行者天国，身着浴衣的人们在灯笼的映照下，享受着夏夜的清凉与热闹。</p>
<h2>秋之枫：古寺红叶</h2>
<p>当秋风染红了枫叶，京都又呈现出另一种绝美的姿态。东福寺的通天桥、永观堂的池泉回游式庭园，红叶与古建筑的完美融合，构成了日本最具代表性的秋日画卷。</p>
<h2>冬之雪：寂静之美</h2>
<p>京都的冬天虽然寒冷，但雪后的金阁寺——那银装素裹中的金色楼阁，是无数摄影师梦寐以求的画面。而龙安寺的枯山水庭园在白雪覆盖下，更显禅意深远。</p>`,
    category: '亚洲文化',
    categorySlug: 'wenhua',
    author: '林清雅',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20author%20portrait%20in%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20expression%2C%20clean%20cream%20background&width=80&height=80&seq=avatar-linqingya&orientation=squarish',
    date: '2026-08-10',
    readTime: '12 分钟',
    image: 'https://readdy.ai/api/search-image?query=Kyoto%20ancient%20temple%20in%20autumn%20with%20red%20maple%20leaves%2C%20traditional%20Japanese%20architecture%20with%20wooden%20veranda%2C%20serene%20zen%20garden%20atmosphere%2C%20warm%20golden%20hour%20light%2C%20shallow%20depth%20of%20field%2C%20artistic%20travel%20photography%20style%20on%20neutral%20warm%20cream%20background&width=1200&height=675&seq=article-kyoto-01&orientation=landscape',
    imageAlt: '京都古寺秋日红叶美景',
    tags: ['日本', '京都', '传统文化', '旅行', '匠人'],
    featured: true,
    hot: true,
    views: 15680,
  },
  {
    id: 2,
    title: '东南亚美食地图：从曼谷街头到新加坡米其林的味觉盛宴',
    excerpt: '一碗冬阴功、一份肉骨茶、一串沙爹——东南亚的美食世界丰富多彩。跟随我们走遍泰国、马来西亚、新加坡、越南，探寻最地道的亚洲味道。',
    content: `<p>东南亚，这片被热带阳光眷顾的土地，孕育了世界上最丰富多彩的美食文化之一。从街边小摊到米其林星级餐厅，每一口都是味蕾的冒险。</p>
<h2>泰国：酸辣甜咸的完美平衡</h2>
<p>曼谷的唐人街（Yaowarat）是美食爱好者的天堂。夜幕降临后，整条街道变身为巨大的露天食堂。一碗热腾腾的冬阴功汤，酸辣交织中透着椰奶的醇厚；一份泰式炒河粉（Pad Thai），甜咸适中，花生碎与青柠的搭配令人回味无穷。</p>
<h2>马来西亚：多元文化的味觉交响</h2>
<p>槟城的乔治市被联合国教科文组织列为世界遗产，这里的美食同样值得被列入世界非物质文化遗产。福建面、炒粿条、椰浆饭——马来人、华人和印度人的饮食文化在这里交融，创造出独一无二的娘惹菜系。</p>
<h2>越南：清新自然的美食哲学</h2>
<p>一碗地道的越南河粉（Phở），汤头清澈却味道浓郁，配上新鲜的香草和青柠，是越南人对"鲜"字最完美的诠释。胡志明市的街头，随处可见坐在小塑料凳上享用美食的本地人，这种接地气的用餐体验本身就是一道风景。</p>
<h2>新加坡：米其林与小贩中心</h2>
<p>新加坡是唯一一个拥有米其林星级小贩摊位的国家。了凡香港油鸡饭面——这家位于牛车水的小摊，以不到3新币的价格提供米其林星级美食，成为了新加坡美食传奇的最佳注脚。</p>`,
    category: '生活方式',
    categorySlug: 'shenghuo',
    author: '王大明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20food%20blogger%20portrait%20in%20warm%20natural%20light%2C%20friendly%20smile%2C%20casual%20style%2C%20simple%20cream%20background&width=80&height=80&seq=avatar-wangdaming&orientation=squarish',
    date: '2026-08-08',
    readTime: '15 分钟',
    image: 'https://readdy.ai/api/search-image?query=Southeast%20Asian%20street%20food%20market%20at%20night%20with%20steaming%20food%20stalls%2C%20colorful%20fresh%20ingredients%20and%20spices%20displayed%2C%20warm%20ambient%20lighting%20from%20hanging%20lanterns%2C%20rich%20textures%20of%20herbs%20and%20chilies%2C%20food%20photography%20style%20on%20dark%20warm%20background&width=1200&height=675&seq=article-seafood-02&orientation=landscape',
    imageAlt: '东南亚街头美食夜市',
    tags: ['东南亚', '美食', '泰国', '新加坡', '旅行'],
    featured: true,
    hot: true,
    views: 23450,
  },
  {
    id: 3,
    title: 'K-POP的全球征服之路：从韩国本土到世界舞台的文化现象',
    excerpt: '从BTS到BLACKPINK，从《江南Style》到《Dynamite》，韩国流行音乐如何在短短二十年间征服全球？深度解析K-POP的工业化造星体系与全球化战略。',
    content: `<p>2026年，K-POP已经成为一种无法忽视的全球文化现象。但这并非一蹴而就——它背后是一套精密运作的工业化造星体系。</p>
<h2>练习生制度：严苛背后的逻辑</h2>
<p>SM娱乐、YG娱乐、JYP娱乐——韩国三大娱乐公司建立了系统化的练习生培养体系。从舞蹈、声乐到语言、礼仪，练习生们经过数年甚至十数年的训练，才能在激烈的竞争中脱颖而出。</p>
<h2>社交媒体时代的精准营销</h2>
<p>K-POP的成功离不开对社交媒体的精准运用。YouTube、Twitter、TikTok、Weverse——这些平台成为了偶像与粉丝之间直接沟通的桥梁。粉丝不再是单向的内容消费者，而是成为了内容传播的积极参与者。</p>
<h2>全球化与本土化的平衡</h2>
<p>有趣的是，K-POP在走向全球的同时，也在进行着巧妙的本土化调整。BTS的英文单曲、BLACKPINK与西方艺人的合作、NCT的多国成员配置——这些策略让K-POP在全球范围内获得了前所未有的影响力。</p>`,
    category: '亚洲娱乐',
    categorySlug: 'yule',
    author: '陈美玲',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20entertainment%20journalist%20portrait%2C%20confident%20professional%20look%2C%20warm%20natural%20lighting%2C%20minimalist%20cream%20background&width=80&height=80&seq=avatar-chenmeiling&orientation=squarish',
    date: '2026-08-07',
    readTime: '10 分钟',
    image: 'https://readdy.ai/api/search-image?query=K-pop%20concert%20stage%20with%20colorful%20dynamic%20lighting%20and%20massive%20crowd%2C%20energetic%20atmosphere%20with%20light%20sticks%20creating%20ocean%20of%20colors%2C%20wide%20angle%20view%20from%20back%20of%20stadium%2C%20music%20festival%20photography%20style%20on%20dark%20background&width=1200&height=675&seq=article-kpop-03&orientation=landscape',
    imageAlt: 'K-POP演唱会现场盛况',
    tags: ['K-POP', '韩国', '娱乐', '音乐', '文化现象'],
    featured: true,
    hot: false,
    views: 45200,
  },
  {
    id: 4,
    title: '印度科技崛起：从硅谷CEO到全球创业生态的亚洲力量',
    excerpt: '微软、谷歌、Adobe——这些科技巨头的CEO都是印度裔。是什么让印度成为全球科技人才的摇篮？深度解析印度的教育体系、创业生态与人才输出。',
    content: `<p>在全球科技版图上，印度裔高管和创业者的身影无处不在。这一现象背后，是印度独特的教育体系和创业生态。</p>
<h2>IIT：印度的"麻省理工"</h2>
<p>印度理工学院（IIT）被誉为全球最难考入的大学之一，录取率不到2%。这里培养出了谷歌CEO桑达尔·皮查伊、麦肯锡前全球总裁拉贾特·古普塔等无数科技与商业领袖。</p>
<h2>班加罗尔：亚洲的硅谷</h2>
<p>班加罗尔聚集了超过8000家科技创业公司，是印度当之无愧的科技之都。从Infosys到Flipkart，从Ola到Zomato，印度独角兽企业正以惊人的速度崛起。</p>
<h2>人才回流与全球化</h2>
<p>随着印度本土创业生态的成熟，越来越多在海外成功的印度裔人才选择回国创业或投资，形成了良性的人才循环。这一趋势正在重塑全球科技产业的力量格局。</p>`,
    category: '亚洲资讯',
    categorySlug: 'zixun',
    author: '赵志远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20tech%20analyst%20portrait%20in%20modern%20office%20setting%2C%20intellectual%20professional%20look%2C%20warm%20indoor%20lighting%2C%20simple%20cream%20background&width=80&height=80&seq=avatar-zhaozhiyuan&orientation=squarish',
    date: '2026-08-05',
    readTime: '8 分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20campus%20in%20Bangalore%20India%20with%20glass%20buildings%20and%20tropical%20gardens%2C%20young%20professionals%20walking%20in%20campus%2C%20sunny%20day%20with%20palm%20trees%2C%20clean%20corporate%20photography%20style%20on%20warm%20neutral%20background&width=1200&height=675&seq=article-india-tech-04&orientation=landscape',
    imageAlt: '班加罗尔科技园区',
    tags: ['印度', '科技', '创业', '硅谷', '人才'],
    featured: false,
    hot: true,
    views: 18700,
  },
  {
    id: 5,
    title: '中日韩美妆趋势对比：从韩式水光肌到日式透明感的亚洲美',
    excerpt: '亚洲美妆市场正在经历前所未有的变革。韩式水光肌、日式透明感、中式新国风——三大美妆流派各有千秋，让我们一探亚洲美妆的最新潮流密码。',
    content: `<p>亚洲美妆市场正在经历一场前所未有的变革。中日韩三大美妆强国各自发展出独特的美学理念和产品体系。</p>
<h2>韩式美妆：水光肌与创新科技</h2>
<p>韩式美妆以"水光肌"闻名全球。从BB霜到气垫粉底，从蜗牛霜到发酵精华，韩国美妆品牌在产品创新方面一直走在世界前列。2026年，韩式"玻璃肌"（Glass Skin）仍然是全球美妆界的顶级追求。</p>
<h2>日式美妆：透明感与匠心品质</h2>
<p>日式美妆追求的是"透明感"——那种由内而外散发出的自然光泽。资生堂、SK-II、CPB——这些日本品牌凭借数十年甚至上百年的研发沉淀，在高端美妆市场占据着不可撼动的地位。</p>
<h2>中式美妆：新国风的崛起</h2>
<p>完美日记、花西子、毛戈平——中国美妆品牌正在用"新国风"美学征服年轻消费者。将传统中国元素与现代美妆科技相结合，中式美妆正在成为亚洲美妆版图上不可忽视的新力量。</p>`,
    category: '产品服务',
    categorySlug: 'chanpin',
    author: '林清雅',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20author%20portrait%20in%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20expression%2C%20clean%20cream%20background&width=80&height=80&seq=avatar-linqingya&orientation=squarish',
    date: '2026-08-03',
    readTime: '9 分钟',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20beauty%20cosmetics%20flat%20lay%20with%20skincare%20bottles%20and%20makeup%20products%20on%20marble%20surface%2C%20soft%20natural%20lighting%20with%20cherry%20blossom%20petals%2C%20minimalist%20product%20photography%20style%20on%20warm%20cream%20background&width=1200&height=675&seq=article-beauty-05&orientation=landscape',
    imageAlt: '亚洲美妆产品展示',
    tags: ['美妆', '韩国', '日本', '中国', '护肤'],
    featured: false,
    hot: false,
    views: 12300,
  },
  {
    id: 6,
    title: '巴厘岛瑜伽静修：在热带天堂寻找身心灵的平衡',
    excerpt: '乌布——这个巴厘岛的文化心脏，已经成为全球瑜伽爱好者的朝圣之地。在稻田和热带雨林的环绕中，体验一场深度的身心灵之旅。',
    content: `<p>巴厘岛的乌布（Ubud）如同一块磁石，吸引着来自世界各地的瑜伽修行者和灵性探索者。</p>
<h2>乌布：瑜伽者的天堂</h2>
<p>坐落于巴厘岛中部的乌布，有着独特的能量场。翠绿的梯田、古老的印度教寺庙、蜿蜒的阿勇河——这里的自然环境为瑜伽修行提供了完美的背景。每年，数以万计的瑜伽爱好者来到乌布，参加各种瑜伽静修营和工作坊。</p>
<h2>巴厘岛瑜伽节</h2>
<p>每年三月的巴厘岛灵性节（BaliSpirit Festival）是东南亚最大的瑜伽和灵性音乐节。来自全球的瑜伽大师、冥想导师和灵性音乐家齐聚乌布，为参与者带来沉浸式的体验。</p>
<h2>从身体到心灵的旅程</h2>
<p>在乌布，瑜伽不只是体式的练习，更是一种生活方式的体现。从清晨的哈他瑜伽到傍晚的阴瑜伽，从素食料理课程到声音疗愈工作坊，这里的每一天都是对身心灵的深度滋养。</p>`,
    category: '生活方式',
    categorySlug: 'shenghuo',
    author: '王大明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20food%20blogger%20portrait%20in%20warm%20natural%20light%2C%20friendly%20smile%2C%20casual%20style%2C%20simple%20cream%20background&width=80&height=80&seq=avatar-wangdaming&orientation=squarish',
    date: '2026-08-01',
    readTime: '11 分钟',
    image: 'https://readdy.ai/api/search-image?query=Serene%20Bali%20yoga%20retreat%20with%20open%20air%20pavilion%20overlooking%20lush%20green%20rice%20terraces%2C%20morning%20mist%20over%20tropical%20landscape%2C%20peaceful%20meditation%20atmosphere%2C%20warm%20golden%20sunrise%20light%2C%20travel%20photography%20style%20on%20warm%20neutral%20background&width=1200&height=675&seq=article-bali-06&orientation=landscape',
    imageAlt: '巴厘岛瑜伽静修',
    tags: ['巴厘岛', '瑜伽', '静修', '旅行', '健康'],
    featured: true,
    hot: false,
    views: 9800,
  },
  {
    id: 7,
    title: '东京奥运会后的日本体育产业发展与城市更新',
    excerpt: '2020东京奥运会虽然已经落幕，但它对日本体育产业和城市发展的深远影响才刚刚开始显现。从新国立竞技场到湾岸地区的全面焕新。',
    content: `<p>东京奥运会不仅仅是一场体育盛事，更是日本城市更新和体育产业升级的重要催化剂。</p>
<h2>场馆遗产的活用</h2>
<p>新国立竞技场——这座由隈研吾设计的"森林体育场"，在奥运会后成功转型为多功能的体育娱乐综合体，每年举办超过200场活动，吸引了数百万游客。</p>
<h2>湾岸地区的蜕变</h2>
<p>位于东京湾的选手村在赛后华丽变身为"晴海Flag"——一个可容纳12000人的现代化生态社区。氢能源巴士、自动驾驶出租车、智能垃圾分类系统，这里成为了日本智慧城市的最新样板。</p>
<h2>体育科技的加速</h2>
<p>奥运会推动了日本体育科技的快速发展。从可穿戴设备到AI运动分析，从VR观赛体验到电子竞技的规范化，日本正在用科技重新定义体育产业的未来。</p>`,
    category: '东亚专区',
    categorySlug: 'dongya',
    author: '赵志远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20tech%20analyst%20portrait%20in%20modern%20office%20setting%2C%20intellectual%20professional%20look%2C%20warm%20indoor%20lighting%2C%20simple%20cream%20background&width=80&height=80&seq=avatar-zhaozhiyuan&orientation=squarish',
    date: '2026-07-28',
    readTime: '10 分钟',
    image: 'https://readdy.ai/api/search-image?query=Tokyo%20new%20national%20stadium%20modern%20architecture%20with%20wooden%20lattice%20design%20by%20Kengo%20Kuma%2C%20surrounded%20by%20green%20trees%20under%20blue%20sky%2C%20architectural%20photography%20style%20on%20clean%20neutral%20background&width=1200&height=675&seq=article-tokyo-07&orientation=landscape',
    imageAlt: '东京新国立竞技场',
    tags: ['日本', '体育', '东京', '城市更新', '科技'],
    featured: false,
    hot: true,
    views: 11300,
  },
  {
    id: 8,
    title: '越南数字经济腾飞：东南亚下一个独角兽工厂',
    excerpt: '凭借年轻的人口结构、高速的互联网普及率和积极的政府政策，越南正迅速崛起为东南亚最具活力的数字经济体之一。',
    content: `<p>当人们谈论东南亚数字经济时，新加坡和印尼往往是关注的焦点。但越南——这个拥有近一亿人口的国家——正在悄悄成为东南亚最具潜力的科技市场。</p>
<h2>人口红利与数字化浪潮</h2>
<p>越南拥有东南亚最年轻的人口结构，中位年龄仅为31岁。超过70%的人口使用互联网，智能手机普及率高达73%。这些年轻、精通技术的消费者为数字经济的发展提供了肥沃的土壤。</p>
<h2>本土独角兽的崛起</h2>
<p>VNG Corporation——被誉为"越南小腾讯"——是该国第一家科技独角兽。Momo电子钱包、Tiki电商平台、VNPay数字支付——越南本土科技企业正在各个赛道与国际巨头展开激烈竞争。</p>
<h2>全球资本的青睐</h2>
<p>2025年，越南科技创业公司共获得超过45亿美元的风险投资，创下历史新高。从软银到淡马锡，从红杉到纪源资本，全球顶级投资机构纷纷在越南布局。</p>`,
    category: '东南亚专区',
    categorySlug: 'dongnanya',
    author: '陈美玲',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20entertainment%20journalist%20portrait%2C%20confident%20professional%20look%2C%20warm%20natural%20lighting%2C%20minimalist%20cream%20background&width=80&height=80&seq=avatar-chenmeiling&orientation=squarish',
    date: '2026-07-25',
    readTime: '9 分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Ho%20Chi%20Minh%20City%20skyline%20at%20sunset%20with%20glass%20skyscrapers%20reflecting%20warm%20golden%20light%2C%20busy%20urban%20streets%20with%20motorbikes%2C%20dynamic%20cityscape%20photography%20style%20on%20warm%20neutral%20background&width=1200&height=675&seq=article-vietnam-08&orientation=landscape',
    imageAlt: '胡志明市现代化天际线',
    tags: ['越南', '数字经济', '创业', '东南亚', '科技'],
    featured: false,
    hot: false,
    views: 8700,
  },
  {
    id: 9,
    title: '泰式按摩的千年疗愈智慧：从寺庙到全球水疗中心',
    excerpt: '泰式按摩（Nuad Thai）已被联合国教科文组织列入人类非物质文化遗产。这项源于古印度阿育吠陀的疗愈艺术，如何在全球健康产业中绽放光彩？',
    content: `<p>2019年，泰式按摩（Nuad Thai）被联合国教科文组织正式列入人类非物质文化遗产代表作名录。这一认可，标志着这项拥有2500多年历史的疗愈艺术获得了全球性文化地位的确认。</p>
<h2>寺庙中的医学传统</h2>
<p>泰式按摩的起源可以追溯到2500年前，与佛教的传播密切相关。在泰国，寺庙不仅是宗教场所，也是传统医学的中心。卧佛寺（Wat Pho）至今仍是泰国传统医学和按摩的最高学府。</p>
<h2>能量线与瑜伽伸展</h2>
<p>泰式按摩的核心理念是"森线"（Sen Lines）——人体内十条主要的能量通道。通过有节奏的按压和瑜伽式的被动伸展，按摩师帮助能量在体内自由流动，达到身心平衡的效果。</p>
<h2>全球化与标准化</h2>
<p>如今，泰式按摩已经遍布全球。从曼谷的豪华水疗中心到纽约的精品健康工作室，泰式按摩以其独特的疗愈效果赢得了全球消费者的青睐。泰国政府也积极推动泰式按摩的标准化和国际化。</p>`,
    category: '亚洲文化',
    categorySlug: 'wenhua',
    author: '林清雅',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20author%20portrait%20in%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20expression%2C%20clean%20cream%20background&width=80&height=80&seq=avatar-linqingya&orientation=squarish',
    date: '2026-07-22',
    readTime: '8 分钟',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Thai%20massage%20room%20with%20warm%20candlelight%2C%20wooden%20floor%2C%20white%20linen%2C%20aromatic%20herbs%20and%20flowers%20arranged%20beautifully%2C%20serene%20spa%20atmosphere%2C%20wellness%20photography%20style%20on%20warm%20cream%20background&width=1200&height=675&seq=article-thai-massage-09&orientation=landscape',
    imageAlt: '传统泰式按摩空间',
    tags: ['泰国', '按摩', '健康', '文化', '非物质文化遗产'],
    featured: true,
    hot: false,
    views: 14200,
  },
  {
    id: 10,
    title: '亚洲电子竞技的黄金时代：从网吧到十万人体育场',
    excerpt: '从首尔到上海，从马尼拉到雅加达，亚洲电子竞技产业正在以前所未有的速度发展。职业选手年薪千万、赛事奖金破亿，电竞已成为亚洲年轻人的主流文化。',
    content: `<p>2026年，亚洲电子竞技产业的总产值已经突破200亿美元大关。从PC时代的星际争霸到移动端的王者荣耀，亚洲始终是全球电竞产业的中心。</p>
<h2>韩国：电竞的诞生地</h2>
<p>韩国被公认为现代电子竞技的发源地。1990年代末，随着宽带互联网的普及和PC房（网吧）文化的兴起，星际争霸成为了国民级游戏。OGN、MBC Game等专业电竞频道的出现，让电竞从地下文化变成了主流娱乐。</p>
<h2>中国：全球最大的电竞市场</h2>
<p>凭借庞大的人口基数和移动互联网的普及，中国已经成为全球最大的电竞市场。王者荣耀职业联赛（KPL）的总决赛观看人数超过5亿，英雄联盟全球总决赛（S赛）每次在中国举办都会引发全民关注。</p>
<h2>东南亚：移动电竞的新热土</h2>
<p>在智能手机普及率极高的东南亚，移动电竞正在迅速崛起。无尽对决（Mobile Legends）在印尼、菲律宾和马来西亚拥有超过一亿月活跃用户，成为了东南亚年轻人的社交货币。</p>`,
    category: '亚洲娱乐',
    categorySlug: 'yule',
    author: '赵志远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20tech%20analyst%20portrait%20in%20modern%20office%20setting%2C%20intellectual%20professional%20look%2C%20warm%20indoor%20lighting%2C%20simple%20cream%20background&width=80&height=80&seq=avatar-zhaozhiyuan&orientation=squarish',
    date: '2026-07-20',
    readTime: '12 分钟',
    image: 'https://readdy.ai/api/search-image?query=Massive%20esports%20stadium%20filled%20with%20thousands%20of%20fans%2C%20huge%20LED%20screens%20displaying%20game%2C%20dramatic%20stage%20lighting%20with%20laser%20beams%2C%20electric%20atmosphere%20at%20gaming%20championship%2C%20event%20photography%20style%20on%20dark%20background&width=1200&height=675&seq=article-esports-10&orientation=landscape',
    imageAlt: '电竞比赛现场盛况',
    tags: ['电竞', '游戏', '韩国', '中国', '东南亚'],
    featured: false,
    hot: true,
    views: 32100,
  },
  {
    id: 11,
    title: '喜马拉雅山麓的神秘王国：不丹的幸福哲学与可持续发展',
    excerpt: '不丹——这个被喜马拉雅山脉环抱的小国，以"国民幸福总值"（GNH）取代GDP作为发展指标。这种独特的发展理念，为现代世界提供了怎样的启示？',
    content: `<p>在世界各国竞相追求GDP增长的今天，不丹却选择了一条不同的道路——用"国民幸福总值"（Gross National Happiness, GNH）来衡量国家的发展。</p>
<h2>GNH的四大支柱</h2>
<p>不丹的GNH体系建立在四大支柱之上：可持续发展、文化保护、环境保护和良政善治。这种发展理念不否定经济增长的重要性，但强调物质与精神的平衡发展。</p>
<h2>碳中和的先行者</h2>
<p>不丹是世界上唯一的负碳排放国家。其森林覆盖率超过70%，宪法规定全国至少60%的土地必须被森林覆盖。水电出口不仅满足了国内的能源需求，还为邻国提供了清洁能源。</p>
<h2>传统与现代的平衡</h2>
<p>不丹在1999年才引入电视和互联网，但这并不意味着它与世隔绝。相反，不丹选择了一条审慎的现代化道路，在拥抱科技的同时，努力保护自己的文化传统和自然环境。</p>`,
    category: '南亚专区',
    categorySlug: 'nanya',
    author: '陈美玲',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20entertainment%20journalist%20portrait%2C%20confident%20professional%20look%2C%20warm%20natural%20lighting%2C%20minimalist%20cream%20background&width=80&height=80&seq=avatar-chenmeiling&orientation=squarish',
    date: '2026-07-18',
    readTime: '7 分钟',
    image: 'https://readdy.ai/api/search-image?query=Bhutan%20tiger%20nest%20monastery%20perched%20on%20cliff%20in%20Himalayan%20mountains%2C%20misty%20morning%20with%20prayer%20flags%20fluttering%2C%20dramatic%20mountain%20landscape%2C%20travel%20photography%20style%20on%20warm%20neutral%20background&width=1200&height=675&seq=article-bhutan-11&orientation=landscape',
    imageAlt: '不丹虎穴寺悬崖景观',
    tags: ['不丹', '幸福', '可持续发展', '喜马拉雅', '文化'],
    featured: false,
    hot: false,
    views: 7600,
  },
  {
    id: 12,
    title: '亚洲独立设计师品牌的全球突围：从上海时装周到巴黎买手店',
    excerpt: 'Uma Wang、Feng Chen Wang、Samuel Guì Yang——这些亚洲独立设计师品牌正在国际时尚舞台上崭露头角，她们的成功之路揭示了亚洲时尚产业的全新可能。',
    content: `<p>曾几何时，"亚洲时尚"在国际语境中等同于"快时尚"和"代工制造"。但如今，一批亚洲独立设计师正在用自己的方式改写这一叙事。</p>
<h2>上海时装周：亚洲时尚的新地标</h2>
<p>上海时装周已经成为全球时尚产业不可忽视的重要力量。与巴黎、米兰、纽约、伦敦四大时装周不同，上海时装周更注重扶持独立设计师和中国本土品牌，为亚洲设计师提供了展示才华的国际舞台。</p>
<h2>从东方美学到全球叙事</h2>
<p>新一代亚洲设计师不再满足于简单的"东方元素"堆砌。Uma Wang以其对材质的极致追求在国际买手店大获成功；Feng Chen Wang将中国传统文化与现代街头风格完美融合；Samuel Guì Yang则将东方女性的优雅与当代剪裁相结合。</p>
<h2>DTC模式的崛起</h2>
<p>社交媒体的普及让亚洲独立设计师可以直接触达全球消费者。Instagram、小红书、TikTok——这些平台成为了品牌建立认知和驱动销售的核心渠道。</p>`,
    category: '产品服务',
    categorySlug: 'chanpin',
    author: '林清雅',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20author%20portrait%20in%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20expression%2C%20clean%20cream%20background&width=80&height=80&seq=avatar-linqingya&orientation=squarish',
    date: '2026-07-15',
    readTime: '9 分钟',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20fashion%20week%20runway%20show%20with%20models%20wearing%20modern%20Asian%20designer%20clothing%2C%20dramatic%20runway%20lighting%2C%20minimalist%20contemporary%20aesthetic%2C%20fashion%20photography%20style%20on%20warm%20neutral%20background&width=1200&height=675&seq=article-fashion-12&orientation=landscape',
    imageAlt: '上海时装周T台走秀',
    tags: ['时尚', '设计师', '上海', '品牌', '独立设计'],
    featured: false,
    hot: false,
    views: 18900,
  },
];